module.exports = __webpack_public_path__ + "static/media/tianshangshanadj.29dc3bcb.png";